<div
	[class.h-[60vh]]="!(controller.isHandsetLandscape$ | async)"
	[class.h-screen]="controller.isHandsetLandscape$ | async"
	class="flex w-full"
>
	<p-card
		[styleClass]="(controller.isHandsetLandscape$ | async) ? '' : 'h-full'"
		class="w-full"
		styleClass="px-3"
	>
		<div
			[class.h-full]="!(controller.isHandsetLandscape$ | async)"
			[class.h-screen]="controller.isHandsetLandscape$ | async"
			class="flex flex-col"
		>
			<spr-coachee-profile-notes-header></spr-coachee-profile-notes-header>
			<spr-coachee-profile-notes-filter></spr-coachee-profile-notes-filter>
			<div class="flex-1 relative">
				<ng-scrollbar
					(reached)="onReached()"
					class="absolute inset-0"
					infiniteScroll
					visibility="hover"
				>
					<spr-coachee-profile-notes-note
						*ngFor="let note of controller.coacheeNotes$ | async"
						[note]="note"
					>
						<p-button
							[pTooltip]="controller.i18n + '.table.action.deleteNote' | translate"
							(click)="onDeleteNoteClick(note)"
							icon="fak fa-str-trash text-lg"
							styleClass="p-button-link p-0"
						></p-button>
					</spr-coachee-profile-notes-note>
				</ng-scrollbar>
			</div>
		</div>
	</p-card>
</div>
